import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import Dock from "../../Common/Dock";
import { Icon } from "../../Common/Icon";
import FiltersForm from "./FiltersForm";

export default class FiltersSidePanel extends PureComponent {
  static propTypes = {
    onSearch: PropTypes.func.isRequired,
    onSetFilters: PropTypes.func.isRequired,
    panelVisibility: PropTypes.func.isRequired,
    customersFilters: PropTypes.object,
    customersSelections: PropTypes.array,
    isMobile: PropTypes.bool,
    isVisible: PropTypes.bool,
    position: PropTypes.string,
    userMetadata: PropTypes.object
  };

  static defaultProps = {
    customersFilters: {},
    customersSelections: [],
    isVisible: true,
    isMobile: false,
    position: "right",
    userMetadata: {}
  };

  get dockSize() {
    return this.props.isMobile ? 1 : 0.3;
  }

  get iconClassNames() {
    const { isMobile, isVisible } = this.props;
    return classNames(isMobile ? "side-panel__close-mobile" : "side-panel__close", isVisible && "--visible");
  }

  get iconId() {
    return this.props.isMobile ? "back" : "x";
  }

  handleSearch = selectedFilters => {
    this.props.onSearch(selectedFilters);
    this.props.panelVisibility(false);
  };

  handleSubmit = selectedFilters => {
    this.props.onSetFilters(selectedFilters);
  };

  handleVisibleChange = () => this.props.panelVisibility(false);

  render() {
    return (
      <Dock position={this.props.position} isVisible={this.props.isVisible} onVisibleChange={this.handleVisibleChange} size={this.dockSize}>
        <Icon onClick={this.handleVisibleChange} className={this.iconClassNames} id={this.iconId} />
        {this.props.isVisible && (
          <FiltersForm
            initialValues={this.props.customersFilters}
            customersSelections={this.props.customersSelections}
            onSearch={this.handleSearch}
            onSubmit={this.handleSubmit}
            customersFilters={this.props.userMetadata.customersFilters}
          />
        )}
      </Dock>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Customer/Filters/FiltersSidePanel.js